const Spacer = ({ data }) => {
  return <div style={{ height: data.gap && data.gap + 'px' }}></div>
}

export default Spacer
